<template>
  <div class="skeleton">
    <header
      v-if="withHeader"
      class="skeleton__header"
    >
      <ElSkeletonItem class="skeleton__header__sup" />
      <ElSkeletonItem class="skeleton__header__sub" />
    </header>
    <div
      class="skeleton__content"
      :class="{
        skeleton__content__picture: !Boolean(withHeader && withFooter),
      }"
    >
      <img
        src="/img/empty/skeleton.png"
        :class="[
          Boolean(withHeader && withFooter) ? 'max-content' : 'min-content',
        ]"
        alt="skeleton-card"
      />
    </div>
    <footer
      v-if="withFooter"
      class="skeleton__footer"
    >
      <ElSkeletonItem class="skeleton__footer__sup" />
      <ElSkeletonItem class="skeleton__footer__sub" />
    </footer>
  </div>
</template>

<script setup lang="ts">
import { ElSkeletonItem } from 'element-plus';

interface Props {
  withHeader?: boolean;
  withFooter?: boolean;
}

withDefaults(defineProps<Props>(), {
  withHeader: false,
  withFooter: false,
});
</script>

<style scoped lang="scss">
@import "@/assets/style/include.scss";
.skeleton {
  display: flex;
  flex-direction: column;
  background-color: $color-white;
  border-radius: $modal-content-border-radius;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 12px;

    &__sub {
      width: 51px;
      height: 23px;
      background-color: #ebebeb;
    }
    &__sup {
      width: 72px;
      height: 22px;
      background-color: #ebebeb;
    }
  }
  &__content {
    background-color: $bgLight2;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 173px;

    &__picture {
      border-radius: 12px;
      height: 116px;
    }

    .max-content {
      width: 95px;
      height: 80px;
    }
    .min-content {
      width: 64px;
      height: 54px;
    }
  }
  &__footer {
    padding: 20px 12px;
    display: flex;
    flex-direction: column;
    gap: 5px;

    &__sub {
      width: 167px;
      height: 17px;
      background-color: #ebebeb;
    }
    &__sup {
      width: 208px;
      height: 17px;
      background-color: #ebebeb;
    }
  }
}
</style>
